/**
 * 上传图片的 `accept` 白名单 —— **前端唯一一份**(2026-07-30,7.29 测试反馈任务 6)。
 *
 * ═══ 为什么要收敛 ═══════════════════════════════════════════════════════════
 * 此前全站散着至少三套写法,其中两处**不收 webp**:
 *   - `RefImageUpload`(海报参考图)     "image/png,image/jpeg"
 *   - `AdvisorChat`(小阳发图)          "image/png,image/jpeg"
 *   - 长图/视频/产品那几处              "image/png,image/jpeg,image/webp"
 * 而微信、浏览器另存、小红书保存下来的图**默认就是 webp** —— 用户在文件选择框里
 * 根本挑不中自己的图(灰的),或者挑中了被后端拒。
 *
 * ★后端白名单同批收敛在 `com.gscq.integration.image.UploadImageFormat`,两边口径一致:
 *   位图族 png/jpg/webp;svg 只给「logo / 水印」这类矢量有意义的场景,
 *   不给「一张人物照片」(矢量图拿不到人脸)。
 *
 * ★`accept` 只是文件选择框的过滤,**不是校验** —— 用户仍可拖拽任意文件进来。
 *   真正的闸在后端,报错文案会带上「你传的是什么」。
 */

/** 位图族:绝大多数上传口用这个。 */
export const IMAGE_ACCEPT = "image/png,image/jpeg,image/webp";

/** 位图 + 矢量:logo / 水印(svg 在这里有意义)。 */
export const IMAGE_ACCEPT_WITH_SVG = `${IMAGE_ACCEPT},image/svg+xml`;

/** 纯视频:口播视频专用槽(老板 IP 采集流的可选第二资产)。后端白名单同口径 video/mp4|quicktime。 */
export const VIDEO_ACCEPT = "video/mp4,video/quicktime";

/** 图 + 片:数字人形象(照片形象 / 视频形象两档共用一个选择框)。 */
export const IMAGE_OR_VIDEO_ACCEPT = `${IMAGE_ACCEPT},${VIDEO_ACCEPT}`;
